import { useAuthStore } from '@/shared/stores';

/**
 * Componente que muestra la información del usuario autenticado
 * Renderiza el nombre y rol del usuario extraídos del store de autenticación
 * Se utiliza en el HeaderMaintainer para identificar al usuario activo
 */
const UserSection = () => {
  const name = useAuthStore((state) => state.name);
  const role = useAuthStore((state) => state.role);

  return (
    <div className="flex flex-col text-start md:text-end">
      <span className="font-semibold">{name}</span>
      <span className="font-medium">{role}</span>
    </div>
  );
};

export default UserSection;
